import React from "react";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import Select from "react-select";
import SuperSelect from "../../Misc/SuperSelect";
import FormLine from "../../Misc/FormLine";
import EssenceReference from "../../Essence/EssenceReference";
import EssenceReferenceCisternEdit from "../../Essence/EssenceReferenceCisternEdit";

export default class BunkerUpdate extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
      lines: [],
      currency: [],
      cisterns: {},

      elementPickIdx: false,
      elementPickShow: false,
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.docId !== this.props.docId) {
      this.load();
    }
    this.renderButtons();
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  onLineChange = (idx, key, value) => {
    let { lines } = this.state;
    lines[idx][key] = value;
    this.setState({ lines });
  };

  loadReferences = async () => {
    this.setState({ pending: true });
    let currency = await this.context.api.qr("/currency/list");
    let cisterns = await this.context.api.qo("/cistern/list");
    this.setState({ pending: false, currency, cisterns });
  };

  rowAdd = (idx) => {
    let { lines } = this.state;
    let index = idx || lines.length;
    lines.splice(index, 0, {});
    this.setState({ lines });
  };

  rowRemove = (idx) => {
    let { lines } = this.state;
    lines.splice(idx, 1);
    this.setState({ lines });
  };

  load = async () => {
    let item = {};
    let lines = [];
    let searchParams = new URLSearchParams(
      this.props.location.search.substr(1)
    );

    let append = searchParams.get("append");
    if (append) {
      let appendItems = append.split(",");
      appendItems.forEach((id) => {
        lines.push({ cisternid: id });
      });
    }

    let ship = searchParams.get("ship");
    if (append) {
      item.ship = ship;
    }

    this.setState({ item, lines, pending: false });
    this.context.force();
  };

  save = async () => {
    this.setState({ pending: false });
    let { lines, item } = this.state;

    let items = [];
    lines.forEach((line) => {
      items.push({
        cistern: line.cisternid,
        volume: line.volume,
      });
    });

    let itemsResult = await this.context.api.q(
      "/cistern/volume/current",
      items
    );
    this.setState({ pending: false });
    if (itemsResult !== false) {
      this.context.toast("Изменения сохранены", "success");

      if (item.ship) {
        this.context.redirect(`/bunker/${item.ship}/`);
      } else {
        this.context.redirect(`/bunker/`);
      }
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Сохранить"
          onClick={this.save}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-save"></i>
        </button>
      </>
    );
  };

  onElementPickOpen = (idx) => {
    this.setState({ elementPickShow: true, elementPickIdx: idx });
  };

  onElementPickClose = () => {
    this.setState({ elementPickShow: false });
  };

  onElementPick = (elem) => {
    this.onLineChange(this.state.elementPickIdx, "cisternid", elem.id);
    this.onLineChange(this.state.elementPickIdx, "cisternname", elem.label);
  };

  getCisternLabel = (id) => {
    const { cisterns } = this.state;
    if (cisterns[id]) {
      return cisterns[id].name || "";
    }
    return "";
  };

  render() {
    const { item, notFound, pending, lines } = this.state;
    const { docId } = this.props;
    let title = docId === "add" ? "Состояние судового бункера" : item.label;

    if (notFound) {
      title = "Документ не найден";
      return (
        <div className="container">
          <CrumbsProvider title={title} link="/bunkerorder/" />
          <DefaultNotFound />
        </div>
      );
    }

    return (
      <>
        <EssenceReference
          essence="cistern"
          sort="sequence"
          title="Бункеры"
          showDescription
          show={this.state.elementPickShow}
          onHide={this.onElementPickClose}
          onSelect={this.onElementPick}
          itemEditor={(itemEditorProps) => (
            <EssenceReferenceCisternEdit {...itemEditorProps} />
          )}
          extraFields={["shipname"]}
        />
        <CrumbsProvider title="Судовой бункер" link={`/bunker/${item.ship}/`} />
        <CrumbsProvider title={title} link={`/bunkerupdate/${item.id}/`} />
        <div className="container h-100">
          <div className="row  h-100">
            <div className="col">
              <div className="card card-custom card-stretch">
                <div className="card-body px-5 py-5">
                  <Blocker on={pending}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th width="50%">
                            <i
                              title="Добавить строку"
                              onClick={() => this.rowAdd()}
                              className="fa fa-plus cursor-pointer text-hover-primary mr-2"
                            ></i>
                            Судовой бункер
                          </th>
                          <th width="15%">Кол-во</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lines.map((item, idx) => {
                          let line = item || {};
                          return (
                            <tr key={idx}>
                              <td>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={
                                      this.getCisternLabel(line.cisternid) || ""
                                    }
                                    onDoubleClick={() =>
                                      this.onElementPickOpen(idx)
                                    }
                                    readOnly
                                  />
                                  <div className="input-group-append">
                                    <button
                                      title="Выбрать"
                                      className="btn btn-icon border"
                                      type="button"
                                      onClick={() =>
                                        this.onElementPickOpen(idx)
                                      }
                                    >
                                      <i className="fa icon-md text-muted fa-navicon"></i>
                                    </button>
                                  </div>
                                </div>
                              </td>

                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="flex-grow-1">
                                    <input
                                      className="form-control"
                                      value={item.volume || ""}
                                      size={3}
                                      type="number"
                                      onChange={(e) =>
                                        this.onLineChange(
                                          idx,
                                          "volume",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="ml-3 text-nowrap">
                                    <i
                                      title="Удалить строку"
                                      onClick={() => this.rowRemove(idx)}
                                      className="fa fa-times cursor-pointer text-hover-danger "
                                    ></i>
                                    <i
                                      title="Добавить строку ниже"
                                      onClick={() => this.rowAdd(idx + 1)}
                                      className="fa fa-plus cursor-pointer text-hover-primary ml-2"
                                    ></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Blocker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
